import { defineComponent as _defineComponent } from 'vue'
import { Member,  Shop } from '@/models';
import { Auth } from 'aws-amplify';
import { inject,  ref, toRefs, watch } from 'vue';
import { CardListDto, CardPaymentDto } from '../../../common/card.dto';
import 'dayjs/locale/ja'


interface Props {
  member: Member;
  shop: Shop;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    member: null,
    shop: null
  },
  emits: ['onerror', 'onsuccess'],
  setup(__props: any, { expose, emit }) {

const props = __props as {
  member: Member;
  shop: Shop;
}



const { member, shop } = toRefs(props);



const api: any = inject('api');
const paypay: any = inject('paypay');

const qrResult = ref();
const paypayPollingHandler = ref();

const card = ref<CardListDto>();
const cardKeys = ref();

const pollingPaypayResult = async() => {
  try {
    const paypayResult = await paypay.pollingPaypayPayment(qrResult.value.merchantPaymentId);

    console.log(paypayResult);

    if (paypayResult.status == 'COMPLETED') {
      clearInterval(paypayPollingHandler.value);
      emit('onsuccess');
    }
  }
  catch(e) {
    console.log(e);
    await cancelPaypay();
  }
}

const paymentPaypay = async(price: number, description: string) => {
  try {
    qrResult.value  = await paypay.getPaypayQr({
      amount: price,
      orderDescription: description, 
      clientId: shop.value.paypayApiKey, 
      clientSecret: shop.value.paypayApiSecret, 
      merchantId: shop.value.paypayMerchantId,
      storeId: shop.value.paypayStoreId});
    if (qrResult.value == null) {
      emit('onerror', 'PayPay支払いに失敗しました。');
      return;
    }
    console.log(qrResult.value);

    paypayPollingHandler.value = setInterval(async() => {
      // 期限切れ
      if ((new Date).getTime() > qrResult.value.expiryDate * 1000) {
        cancelPaypay();
        emit('onerror', 'PayPay支払いに失敗しました。');
        return;
      }

      void (async () => {
        await pollingPaypayResult();
      })();
    }, 3000);

    window.open(qrResult.value.url, '_blank');
  }
  catch(e) {
    console.log(e);
    emit('onerror', 'PayPay支払いに失敗しました。');
  }
}

const cancelPaypay = async() => {
  if (paypayPollingHandler.value) {
    clearInterval(paypayPollingHandler.value);
  }
  if (qrResult.value) {
    await paypay.cancelPaypayPayment(qrResult.value.merchantPaymentId);
  }
}

const paymentCard = async(price: number) => {  
  try {
    const cardId = card.value!.cardId!;
    const data: CardPaymentDto = {
      cardId: cardId,
      price: price,
      customerId: member.value!.squareCustomerId!,
      memberId: member.value!.id,
      encryptedKeys: cardKeys.value
    }
    const res = await api.buyPoint(data);
    console.log(res);

    if (!res) {
      emit('onerror', 'カードの支払いに失敗しました。');
      return;
    }

    emit('onsuccess');
  }
  catch(e) {
    console.log(e);
    emit('onerror', 'カードの支払いに失敗しました。');
  }
};

const init = async() => {
  try {
    const authSession = await Auth.currentSession();
    const token = authSession.getAccessToken().getJwtToken();
    paypay.setCognitoToken(token);

    cardKeys.value = await api.generateEncryptedKeys(`${shop.value.squareAppId}$${shop.value.squareLocationId}$${shop.value.squareAccessToken}`);
    const cardList = await api.getCards(member.value.squareCustomerId, cardKeys.value);
    card.value = cardList.filter((x: CardListDto)  => x.cardId == member.value!.currentSquareCardId)[0]; 
  }
  catch(e) {
    console.log(e);
  }
}
init();

expose({
  paymentPaypay,
  paymentCard,
  cancelPaypay
});

return () => {}
}

})